export const isEmail = (email: any) => {
  const str: string = (email || '').toString().trim();

  return str.match(/^[^@]+@[^@]+\.[^@]+$/);
};

export default isEmail;
